import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';
import { Text } from '../typography';

/* ############################################################################
 *  INFO BUBBLE
 *  Info bubble component used for tooltip and simple popover components
 *  It is responsible for the styling only. not for the logic.
 * ######################################################################### */

export type InfoBubbleVariant = 'dark' | 'light';

const textVariants = cva('', {
  variants: {
    variant: {
      dark: 'text-white',
      light: 'text-space',
    },
  },
});

type InfoBubbleBaseProps = {
  variant: InfoBubbleVariant;
  children: React.ReactNode;
  className?: string;
};

export const InfoBubbleHeader = ({
  children,
  variant,
  className,
  ...props
}: InfoBubbleBaseProps) => (
  <Text
    variant="typo-sm-semibold"
    className={cn('w-fit', textVariants({ variant }), className)}
    {...props}>
    {children}
  </Text>
);

export const InfoBubbleText = ({ children, variant, className, ...props }: InfoBubbleBaseProps) => (
  <Text variant="typo-sm" className={cn('w-fit', textVariants({ variant }), className)} {...props}>
    {children}
  </Text>
);

const infoBubbleContentVariants = cva(
  'flex w-fit max-w-[300px] flex-col gap-1 rounded-lg p-3 typo-sm shadow-lg',
  {
    variants: {
      variant: {
        dark: 'bg-space text-white',
        light: 'bg-white text-space',
      },
    },
    defaultVariants: {
      variant: 'dark',
    },
  },
);

type InfoBubbleContentProps = {
  variant: InfoBubbleVariant;
  children: React.ReactNode;
  className?: string;
};

export const InfoBubbleContent = ({
  children,
  variant,
  className,
  ...props
}: InfoBubbleContentProps) => (
  <div className={cn(infoBubbleContentVariants({ variant }), className)} {...props}>
    {children}
  </div>
);

export const infoBubbleArrowVariants = cva(
  'z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]',
  {
    variants: {
      variant: {
        dark: 'bg-space fill-space',
        light: 'bg-white fill-white',
      },
    },
  },
);
